import Header from "@/components/header";
import { MerchantUserDto } from "@/models/club";
import TeamMemberService from "@/modules/team/add/teamService";
import useGetMerchantUserById from "@/services/merchantUser/hooks/useGetMerchantUserById";
import useUpdateMerchantUserServices from "@/services/merchantUser/hooks/useUpdateMerchantUserServices";
import { CreateUserPayloadForm } from "@/services/merchantUser/type";
import { useGetImage } from "@/utilities/helper/getImage";
import {
  Avatar,
  Button,
  Card,
  Container,
  Group,
  LoadingOverlay,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  UserFormProvider,
  useUserForm,
  useUserFormContext,
} from "../add/Context";
import {
  CategoryWithChecked,
  ServiceWithChecked,
} from "@/modules/team/add/teamService/type";
import { useListState } from "@mantine/hooks";
import useIsSmall from "@/hooks/useIsSmall";

function EditTeamMemberServicesContent() {
  const form = useUserFormContext();
  const navigate = useNavigate();
  const {
    mutate: updateMerchantUserServices,
    isLoading: isUpdatingMerchantUserServices,
  } = useUpdateMerchantUserServices();
  const { id } = useParams();

  const { data, isLoading } = useGetMerchantUserById(Number(id));

  const user = data as MerchantUserDto;

  const [selectedServices, handlers] = useListState<CategoryWithChecked>([]);
  const isSmall = useIsSmall();
  // Set default services when user data is loaded
  useEffect(() => {
    if (user?.merchantServices) {
      form.setFieldValue("services", user.merchantServices);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.merchantServices]);

  const submit = (values: CreateUserPayloadForm) => {
    console.log(values);
    const items =
      selectedServices?.flatMap(
        (service) =>
          (service.services as ServiceWithChecked[])
            ?.filter((x) => x.checked)
            .map((service) => service.id ?? 0) || []
      ) || [];
    if (items?.length === 0) {
      notifications.show({
        message: "خدمات را انتخاب کنید",
        color: "yellow",
      });

      return;
    }

    updateMerchantUserServices(
      {
        merchantUserId: user?.id,
        serviceIds: items || [],
      },
      {
        onSuccess() {
          notifications.show({
            message: "عملیات با موفقیت صورت پذیرفت",
            color: "green",
          });
          navigate("/dashboard/teams/teamMembers");
        },
      }
    );
  };

  const { imageUrl } = useGetImage({ image: user?.image });
  return (
    <>
      <LoadingOverlay visible={isLoading} />
      <Header
        title="ویرایش خدمات"
        showBack
        route="/dashboard/teams/teamMembers"
        customComponentHide
        customComponent={
          <>
            <Group>
              <Avatar
                variant="outline"
                color="blue"
                size="md"
                src={imageUrl}
                p="3"
                styles={{
                  image: {
                    borderRadius: "100px",
                  },
                  root: {
                    border: `1px solid ${user?.calendarColor}`,
                  },
                }}
              >
                {user?.firstName?.charAt(0) || ""}
              </Avatar>
              <Text>
                {user?.firstName} {user?.lastName}
              </Text>
            </Group>
          </>
        }
      />
      <Container
        w="100%"
        size="md"
        bg="white"
        mb={isSmall ? "100px" : "0"}
        px="0"
      >
        <Title order={4} pb="0" px="md">
          ویرایش خدمات، {user?.firstName} {user?.lastName}
        </Title>
        <Stack justify="start" flex={1}>
          <form
            onSubmit={form.onSubmit(submit)}
            name="edit-services"
            className="w-100"
            id="edit-services"
          >
            <Stack px="md">
              <TeamMemberService
                showHeader={false}
                handlers={handlers}
                values={selectedServices}
              />
            </Stack>
          </form>
        </Stack>
      </Container>
      {isSmall ? (
        <Card
          styles={{
            root: {
              position: "fixed",
              bottom: 0,
              left: 0,
              right: 0,
              zIndex: 10,
            },
          }}
          withBorder
          radius={0}
        >
          <Button
            type="submit"
            size="lg"
            fullWidth

            form="edit-services"
            loading={isUpdatingMerchantUserServices}
          >
            ویرایش
          </Button>
        </Card>
      ) : (
        <Container w="100%" size="md" bg="white" mb="50px" px="0">
          <Button
            type="submit"
            size="lg"
            fullWidth

            form="edit-services"
            loading={isUpdatingMerchantUserServices}
          >
            ویرایش
          </Button>
        </Container>
      )}
    </>
  );
}

function EditTeamMemberServices() {
  const form = useUserForm({
    initialValues: {
      services: [],
      profileImage: [],
      day: "",
      month: "",
      year: "",
    },
  });

  return (
    <UserFormProvider form={form}>
      <EditTeamMemberServicesContent />
    </UserFormProvider>
  );
}

export default EditTeamMemberServices;
